import React from 'react'
import styled from 'styled-components'

const Wrapper= styled.section`
padding-top: 5%;
padding-bottom: 9%;
h2{
  margin-left: 21px;
  color: #EC632F;
}
.form-div-all{
display: flex;
flex-direction: column;
  }
p{
  margin-left:21px;
  margin-right: 60px;
line-height: 1.3;
margin-bottom: 7%;
margin-top: 7%;
}
.input-1{
  width: 90%;
  height: 47px;
  border: none;

  border-bottom: 1px solid #000;
  display: flex;
  margin: 0 auto;
}
.input-2{
  width: 90%;
  padding-top: 8%;
  padding-bottom: 20%;
  border: none;
  border-bottom: 1px solid #000;
  display: flex;
  margin: 0 auto;
}
.btn-divy{
padding-top: 5%;
margin-left: 21px;
button{
  color: #fff;

  border: none;
  border-radius: 3%;
  background: #EC632F;
  height: 40px;
  font-size: 18px;
  width: 140px;
}
}

.img-2{
  padding-bottom: 5%;
  width: 90%;
  height: 180px;
  object-fit: cover;
  display: flex;
  margin: 0 auto;
}


@media (min-width: 768px) {
  .form-div-all{
display: flex;
gap: 30px;
flex-direction: row;
margin: 0 25px;
  }
  .img-2{
  padding-top: 0%;
  width: 50%;
  height: 330px;
  object-fit: cover;
  display: flex;
  margin: 0 ;
}
h2{
  margin-left: 0px;
}
p{
  margin-left:0px;
  margin-right: 5px;
line-height: 1.3;
margin-bottom: 4%;
margin-top: 2%;
}
.input-1{
  width: 100%;
  height: 40px;
  border: none;

  border-bottom: 1px solid #000;
  display: flex;
  margin: 0 auto;
}
.input-2{
  width: 100%;
  padding-top: 8%;
  padding-bottom: 10%;
  border: none;
  border-bottom: 1px solid #000;
  display: flex;
  margin: 0 auto;
}
.btn-divy{
padding-top: 10%;
margin-left: 0px;
button{
  color: #fff;

  border: none;
  border-radius: 3%;
  background: #EC632F;
  height: 40px;
  font-size: 18px;
  width: 140px;
}
}
}
@media (min-width: 992px) {
  .form-div-all{
display: flex;
gap: 30px;
flex-direction: row;
margin: 0 40px;
  }
  .img-2{
  padding-top: 0%;
  width: 50%;
  height: 400px;
  object-fit: cover;
  display: flex;
  margin: 0 ;
}
h2{
  margin-left: 0px;
}
p{
  margin-left:0px;
  margin-right: 255px;
line-height: 1.3;
margin-bottom: 4%;
margin-top: 2%;
}

.input-1{
  width: 100%;
  height: 50px;
  border: none;

  border-bottom: 1px solid #000;
  display: flex;
  margin: 0 auto;
}
.input-2{
  width: 100%;
  padding-top: 6%;
  padding-bottom: 13%;
  border: none;
  border-bottom: 1px solid #000;
  display: flex;
  margin: 0 auto;
}
.btn-divy{
padding-top: 9%;
margin-left: 0px;
button{
  color: #fff;

  border: none;
  border-radius: 3%;
  background: #EC632F;
  height: 40px;
  font-size: 18px;
  width: 140px;
}
}
}
@media (min-width: 1200px) {
  padding-top: 5%;
padding-bottom: 2%;

  form{
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
  .form-div-all{
display: flex;
gap: 70px;
flex-direction: row-reverse;
margin: 0 90px;
  }
  .img-2{
  padding-top: 0%;
  width: 50%;
  height:460px;
  object-fit: cover;
  display: flex;
  margin: 0 ;
}
h2{
  margin-left: 0px;
  font-size: 33px;
  font-weight: 600;
  padding-bottom: 7%;

}
p{
  margin-left:0px;
  margin-right: 35px;
line-height: 1.3;
margin-bottom: 4%;
margin-top: 2%;
}

.input-1{
  width: 102%;
  height: 50px;
  border: none;
  background: #FDFDFD;
  border-bottom: 1px solid #000;
  display: flex;
  margin: 0 auto;
}
.input-2{
  width: 102%;
  padding-top: 8%;
  padding-bottom: 20%;
  border: none;
  background: #FDFDFD;
  border-bottom: 1px solid #000;
  display: flex;
  margin: 0 auto;
}
.btn-divy{
padding-top: 0%;
margin-left: 0px;
button{
  color: #fff;

  border: none;
  border-radius: 5%;
  background: #EC632F;
  height: 40px;
  font-size: 18px;
  width: 140px;
}
}
}
`
function Contact() {
  return (
    <Wrapper>

<div className='form-div-all'>
        <img  className='img-2' src="./photos/kidswalking.png" alt="photo"/> 
        <div className='div-text-combo'>
        <h2>Contact Us</h2>
      <p>Send us a messege and we will get back to you as soon as we can</p>
      <form>
        <input  className='input-1' type='text' placeholder='Full Name'/>
        <input className='input-1' type='text' placeholder='Email ADDRESS'/>
        <input  className='input-2'type='text' placeholder='Type your Message'/>
        <div className='btn-divy'>
        <button>SEND</button>
        </div>
      </form>
      </div>
      {/* <img  className='img-2' src="./photos/kidswalking.png" alt="photo"/> */}
      </div>
    </Wrapper>
  )
}

export default Contact
